import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { IntegrationsCard } from './integrations_card';
import { useIntegrationsContext } from './integrations_provider';
const integrationsBodyCss = "i4iyhf7";
const IntegrationsBodyContainer = props => <div {...props} className={classNames(integrationsBodyCss, props.className)} />;
const sectionTitleCss = "s1kdx1ex";
const SectionTitle = props => <div {...props} className={classNames(sectionTitleCss, props.className)} />;
const integrationsListCss = "irpw5jj";
const IntegrationsList = props => <div {...props} className={classNames(integrationsListCss, props.className)} />;
export const IntegrationsBody = () => {
  const {
    integrations,
    isLoading,
    handleToggleIntegration
  } = useIntegrationsContext();
  const connectedIntegrations = integrations.filter(integration => integration.connected);
  const notConnectedIntegrations = integrations.filter(integration => !integration.connected);
  if (isLoading) {
    return <IntegrationsBodyContainer>
        <Loader />
      </IntegrationsBodyContainer>;
  }
  if (integrations.length === 0) {
    return null;
  }
  return <IntegrationsBodyContainer>
      {connectedIntegrations.length > 0 && <div>
          <SectionTitle>
            <BodyText size="medium" color={colorTextSecondary} weight="semibold">
              {I18n.t('publisher.personal_settings.meeting_recaps.recording_rules.integrations.connected')}
            </BodyText>
          </SectionTitle>
          <IntegrationsList>
            {connectedIntegrations.map(integration => <IntegrationsCard key={integration.name} integration={integration} onToggle={() => handleToggleIntegration(integration.name)} />)}
          </IntegrationsList>
        </div>}
      {notConnectedIntegrations.length > 0 && <div>
          <SectionTitle>
            <BodyText size="medium" color={colorTextSecondary} weight="semibold">
              {I18n.t('publisher.personal_settings.meeting_recaps.recording_rules.integrations.not_connected')}
            </BodyText>
          </SectionTitle>
          <IntegrationsList>
            {notConnectedIntegrations.map(integration => <IntegrationsCard key={integration.name} integration={integration} onToggle={() => handleToggleIntegration(integration.name)} />)}
          </IntegrationsList>
        </div>}
    </IntegrationsBodyContainer>;
};

require("./integrations_body.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./integrations_body.js");